export const waitSeconds = async (delay: number): Promise<void> =>
  new Promise(function (resolve) {
    setTimeout(resolve, delay * 1000);
  });
